import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import vuetifyEn from 'vuetify/es5/locale/en';
import vuetifyZhHans from 'vuetify/es5/locale/zh-Hans';

import config from './config';
import './auth';

import Index from './Index';
import router from './router';
import store from './store';
import i18n from './i18n';
import { findLocale } from './i18n/locales';

import './directives/FallbackSrc';

const SentryBrowser = () => import(/* webpackChunkName: "Sentry" */ '@sentry/browser');
const SentryIntegrations = () => import(/* webpackChunkName: "Sentry" */ '@sentry/integrations');

(async () => {
  if (config.features.sentryMonitoring) {
    const Sentry = await SentryBrowser();
    const Integrations = await SentryIntegrations();

    Sentry.init({
      dsn: config.sentryDsn,
      integrations: [new Integrations.Vue({ Vue })],
    });
  }

  Vue.config.productionTip = false;

  await store.dispatch('fetchBrand');

  Vue.use(Vuetify);
  const opts = {
    theme: { themes: { light: store.getters.brand.theme } },
    lang: {
      locales: { en: vuetifyEn, zhHans: vuetifyZhHans },
      current: findLocale(i18n.locale).vuetify,
    },
  };

  // eslint-disable-next-line no-new
  const main = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: (h) => h(Index),
    vuetify: new Vuetify(opts),
  });

  store.watch(
    (state, getters) => getters.brand.theme,
    (theme) => {
      main.$vuetify.theme = theme;
    }
  );

  store.watch(
    (state, getters) => getters.locale,
    (locale) => {
      const entry = findLocale(locale);
      i18n.locale = locale;
      main.$vuetify.lang.current = entry.vuetify;
      main.$vuetify.rtl = entry.rtl;
      document.documentElement.lang = locale;
    },
    { immediate: true }
  );
})();
